import { DatabaseEntities } from "../../../common/models/database-entities.model";


export class GrainBoxSizes extends DatabaseEntities<GrainBoxSizes> {
    value: string;
}
